export default "__VITE_ASSET__yRs8FaUp__"